export const NAC_CONTACTS = {
    PHONE: '(11) 4020-2117',
}
